module.exports = __webpack_public_path__ + "static/media/5c8a1c4bfe36da2d5e24d52d-1555063137384-H4_Assistentie_en_begeleiding_in_de_praktijk_SLEEP.5d6720fb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/assets/5c8a1c4bfe36da2d5e24d52d-1555063137384-H4_Assistentie_en_begeleiding_in_de_praktijk_SLEEP.pdf
// module id = 510
// module chunks = 0